import { useDeferredValue, useSyncExternalStore } from "react";

function useMediaQuery(query: string): boolean {
  const mql = window.matchMedia(query);

  const subscribe = (cb: () => void) => {
    mql.addEventListener("change", cb);
    return () => mql.removeEventListener("change", cb);
  };

  return useSyncExternalStore(
    subscribe,
    () => mql.matches,
    () => false
  );
}

export function useIsMobileWidth() {
  return useMediaQuery("(max-width: 768px)");
}

export function useIsDesktop() {
  return useMediaQuery("(min-width: 1024px)");
}

function subscribeResize(callback: () => void) {
  window.addEventListener("resize", callback);
  return () => window.removeEventListener("resize", callback);
}

function getWindowSize() {
  return `${window.innerWidth}-${window.innerHeight}`;
}

function getViewportWidth() {
  return document.documentElement.clientWidth;
}

/** Ширина viewport в пикселях, без скроллбара */
export function useViewportWidth() {
  return useSyncExternalStore(subscribeResize, getViewportWidth, () => 0);
}

export function useWindowSize() {
  const current = useSyncExternalStore(
    subscribeResize,
    getWindowSize,
    getWindowSize
  );
  const deferred = useDeferredValue(current);
  const isResizing = current !== deferred;
  return { windowSize: deferred, isResizing };
}
